import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class ListContractorFilesTask extends GenericRequest {

    _request // ListContractorFilesRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.CONTRACTOR_FILES);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/documentary-library/list/webservices/list-documentary-library/ListContractorFilesTask.js